import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../../assets/Images/Delete.svg";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import { axiosClient, BASE_URL_AI } from "../../../../Constant/apiConstant";
import {
  swalErrorMessage,
  swalWarningMessage,
} from "../../../../Constant/swalMessage";
import { isEmpty } from "../../CommonComponents/Common";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import {
  getCampaignDetailsAllAction,
  getInsightsCampaignAction,
  saveInsightsCampaignAction,
} from "../../ProjectSection/CampaignSection/Store/Campaign.action";
import CustomScrollbars from "../../CommonComponents/CustomScrollbars";

function CreateInsightModal({
  viewCampaignsList = false,
  campaignData,
  show,
  toggle,
  showPopUp,
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const locSearch = new URLSearchParams(location.search);
  const campaignRuns = locSearch.get("campaignRuns");
  const { projectId } = useParams<{ projectId: string }>();
  const reducer: any = useSelector((state) => state);
  const {
    CampaignReducer: { campaignInsights },
  } = reducer;

  const [state, setState] = useState<any>({
    questions: [{ question: "", key: "", type: "" }],
    about: "",
    buttonDisable: false,
    disconnectedArray: [],
    errMsg: "",
  });
  const { questions, about, buttonDisable, disconnectedArray, errMsg } = state;

  useEffect(() => {
    const init = async () => {
      const obj = {
        pageIndex: 1,
        pageSize: 1000,
        live: false,
        callStatus: ["703", "712"],
      };
      const res: any = await dispatch(
        getCampaignDetailsAllAction(projectId, campaignRuns, obj)
      );
      if (res?.length > 0) {
        setState((prev) => ({
          ...prev,
          disconnectedArray: res,
          errMsg: "",
        }));
      } else {
        setState((prev) => ({
          ...prev,
          disconnectedArray: [],
          errMsg: "This campaign is not experiencing any connected calls.",
        }));
      }
    };
    if (viewCampaignsList) init();
  }, []);

  useEffect(() => {
    const init = async () => {
      await dispatch(getInsightsCampaignAction(campaignData?._id));
    };
    init();

    return () => {
      const init = async () => {
        await dispatch(getInsightsCampaignAction(campaignData?._id, true));
      };
      init();
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(campaignInsights)) {
      setState((prev) => ({
        ...prev,
        questions: [...campaignInsights?.questions],
        about: campaignInsights?.about,
      }));
    }
  }, [campaignInsights]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let err = 0;
    const required = ["question", "type", "key"];
    for (const item of questions) {
      required.forEach((o) => {
        if (!item[o]) {
          err++;
        }
      });
    }
    if (err) {
      swalErrorMessage("Please fill all the field first");
      return;
    } else {
      setState((prev) => ({ ...prev, buttonDisable: true }));
      if (viewCampaignsList) sendRecordings();

      const obj1 = {
        questions: [...questions],
        about: about,
        campaignId: campaignData?._id,
      };
      const res2: any = await dispatch(saveInsightsCampaignAction(obj1));
      if (res2) showPopUp();
    }

    setState((prev) => ({ ...prev, buttonDisable: false }));
    toggle();
  };

  const sendRecordings = async () => {
    const sendRecordingData: Array<object> = [];
    for (const item of disconnectedArray) {
      const obj = {
        call_uuid: item?.call_uuid || "",
        phone_number: item?.phone,
      };
      sendRecordingData.push(obj);
      if (item?.redialedCalls?.length > 0 || item?.inboundCalls?.length > 0) {
        const combinedCalls = [...item?.redialedCalls, ...item?.inboundCalls];
        for (const call of combinedCalls) {
          const combinedObj = {
            call_uuid: call?.call_uuid || "",
            phone_number: call?.phone,
            referenceId: call?.referenceId,
            callType: call?.callType,
          };
          sendRecordingData.push(combinedObj);
        }
      }
    }
    const obj = {
      campaign_name: projectId,
      campaign_run_id: campaignRuns,
      questions: [...questions],
      about: about,
      recording_data: sendRecordingData,
    };
    await axiosClient.post(`${BASE_URL_AI}/prompt/entities`, obj);
  };

  const handleChange = (e, idx, val) => {
    const cloneData = state.questions;
    if (val === "key") {
      cloneData[idx][val] = e.target.value.split(" ").join("");
    } else {
      cloneData[idx][val] = e.target.value;
    }
    setState((prev) => ({
      ...prev,
      questions: cloneData,
    }));
  };

  const addMoreColumn = (idx) => {
    if (
      questions[idx]?.question &&
      questions[idx]?.key &&
      questions[idx]?.type
    ) {
      const add = { question: "", key: "", type: "" };
      setState((prev) => ({
        ...prev,
        questions: [add, ...prev.questions],
      }));
    } else {
      swalWarningMessage("Please fill existing one first");
    }
  };

  const removeQuestion = (idx) => {
    const cloneData = state.questions;
    cloneData.splice(idx, 1);
    setState((prev) => ({
      ...prev,
      questions: cloneData,
    }));
  };

  return (
    <CommonModal
      show={show}
      toggle={toggle}
      size={800}
      handleSave={handleSubmit}
      heading={`Ask AI - ${campaignData?.campaignName}`}
      spin={buttonDisable}
      body={
        <Box>
          <CustomScrollbars height="40vh">
            <Box sx={{ gap: 3, my: 1, pb: 6 }}>
              {questions.map((data, idx) => (
                <Box className="my-2" key={idx}>
                  <Box className="flex-between-only">
                    <Box flex={1}>
                      <Box
                        sx={{ display: "flex", gap: 2, alignItems: "center" }}
                      >
                        <Box className="flex-column" flex={1}>
                          <Typography className="font-14-grey my-1">
                            Name
                          </Typography>
                          <TextField
                            placeholder="Enter exact name"
                            value={data.key}
                            onChange={(e) => handleChange(e, idx, "key")}
                            sx={{ ...commonStyles.inputField }}
                          />
                        </Box>

                        <Box className="flex-column" flex={1}>
                          <Typography className="font-14-grey my-1">
                            Type
                          </Typography>
                          <Select
                            displayEmpty
                            value={data.type}
                            onChange={(e) => handleChange(e, idx, "type")}
                            sx={commonStyles.typeSelect}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 200,
                                  overflowY: "auto",
                                },
                              },
                            }}
                          >
                            <MenuItem value="" disabled>
                              Select Type
                            </MenuItem>
                            <MenuItem value="string">Text</MenuItem>
                            <MenuItem value="integer">Number</MenuItem>
                            <MenuItem value="boolean">True/false</MenuItem>
                          </Select>
                        </Box>
                      </Box>

                      <Box className="flex-column">
                        <Typography className="font-14-grey my-1">
                          Question
                        </Typography>
                        <TextField
                          placeholder="Enter what you are looking from call"
                          value={data.question}
                          onChange={(e) => handleChange(e, idx, "question")}
                          multiline
                          maxRows={4}
                          sx={{ ...commonStyles.inputField, width: "100%" }}
                        />
                      </Box>
                    </Box>

                    <Box className="p-2">
                      <IconButton
                        disabled={questions.length === 1}
                        onClick={() => removeQuestion(idx)}
                        sx={{
                          marginTop: 3.5,
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </Box>

                  <span className="font-600-red py-1">{errMsg}</span>

                  {idx === 0 && (
                    <Box className="flex-start" sx={{ pt: 1 }}>
                      <Button
                        onClick={() => addMoreColumn(idx)}
                        variant="outlined"
                        startIcon={
                          <AddIcon
                            style={{
                              color: "#666666",
                              padding: 1,
                              backgroundColor: "white",
                            }}
                          />
                        }
                        sx={commonStyles.addBtn}
                      >
                        Add
                      </Button>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </CustomScrollbars>
        </Box>
      }
      saveButtonText="Create"
      disableSaveButton={errMsg}
    />
  );
}

export default CreateInsightModal;
